var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2632 14L18.8925 23.113C18.9585 23.4822 18.8124 23.8572 18.5142 24.0845L16.606 25.5383C16.248 25.811 15.752 25.811 15.394 25.5383L13.4945 24.091C13.1917 23.8603 13.0461 23.4778 13.119 23.1042L14.8947 14",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14C21.5228 14 26 18.4267 26 23.8872V27.1742C26 27.6651 25.6436 28.0834 25.1589 28.1615L23.8469 28.3726C18.6499 29.2091 13.3501 29.2091 8.15305 28.3726L6.84109 28.1615C6.35638 28.0834 6 27.6651 6 27.1742V23.8872C6 18.4267 10.4772 14 16 14ZM16 14Lnan nanLnan nanL16 14Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoaches);
export default __webpack_public_path__ + "static/media/coaches.076f0997c97315de591375704a682c3f.svg";
export { ForwardRef as ReactComponent };